export default "__VITE_ASSET__XOBvMtxs__"